import { latestSchemaVersion } from '../schema/flameSchema'
import { defineExample, tid, vid } from './util'

// Swirl3D + Polar — twisting vortex columns
export const example31 = defineExample({
  version: latestSchemaVersion,
  metadata: {
    author: 'deluksic',
    name: 'Swirl3D + Polar',
    description: 'twisting vortex columns',
  },
  renderSettings: {
    dimensions: 3,
    exposure: 0.3,
    skipIters: 20,
    drawMode: 'light',
    pointInitMode: 'pointInitUnitSphere',
    camera: { zoom: 1, position: [0, 0] },
    camera3D: {
      theta: 0.3,
      phi: 1.3,
      radius: 2.5,
      target: [0, 0, 0],
      fov: 60,
    },
  },
  transforms: {
    [tid('3d_vortex_a')]: {
      probability: 0.45,
      preAffine: {
        a: 0.7,
        b: 0.3,
        c: 0,
        d: 0,
        e: -0.3,
        f: 0.7,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.85,
        l: 0.05,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.15, y: 0.2 },
      variations: {
        [vid('3d_vortex_a_v0')]: { type: 'swirl3D', weight: 1 },
      },
    },
    [tid('3d_vortex_b')]: {
      probability: 0.35,
      preAffine: {
        a: 0.6,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0.6,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.6,
        l: 0.3,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: -0.3, y: -0.1 },
      variations: {
        [vid('3d_vortex_b_v0')]: { type: 'polar3D', weight: 0.8 },
        [vid('3d_vortex_b_v1')]: { type: 'sinusoidal3D', weight: 0.2 },
      },
    },
    [tid('3d_vortex_c')]: {
      probability: 0.2,
      preAffine: {
        a: 0.8,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0.3,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.8,
        l: -0.05,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0, y: 0.4 },
      variations: {
        [vid('3d_vortex_c_v0')]: { type: 'linear3D', weight: 0.5 },
        [vid('3d_vortex_c_v1')]: { type: 'bubble3D', weight: 0.5 },
      },
    },
  },
})
